export enum CarrierPortalAction {
  ATTACH_DOCUMENT = 'ATTACH_DOCUMENT',
  TENDER_CONFIRM = 'TENDER_CONFIRM',
  TENDER_REJECT = 'TENDER_REJECT',
  UPDATE_EXPECTED_ARRIVAL = 'UPDATE_EXPECTED_ARRIVAL',
  PICK_UP_ARRIVE = 'PICK_UP_ARRIVE',
  PICK_UP_LOAD = 'PICK_UP_LOAD',
  PICK_UP_DEPART = 'PICK_UP_DEPART',
  DROPOFF_ARRIVE = 'DROPOFF_ARRIVE',
  DROPOFF_UNLOAD = 'DROPOFF_UNLOAD',
  DROPOFF_DEPART = 'DROPOFF_DEPART',
  IN_TRANSIT = 'IN_TRANSIT',
  INCIDENT = 'INCIDENT',
}
